import { useUndoHistory } from './useUndoHistory';

// Monte la capture do/undo (per-user, en mémoire). Indépendant de la collab.
const UndoHistoryClient = () => {
  useUndoHistory();
  return null;
};

export default UndoHistoryClient;
